import React, { FC, ReactNode } from 'react';
import { Map } from 'immutable';

import type { ImmutableUser } from 'src/types/user/User';
import Comment from '../../../common/components/Comment';

type TripDetailCommentProps = {
  user?: ImmutableUser;
  children: ReactNode;
};

const TripDetailComment: FC<TripDetailCommentProps> = ({
  user = Map(),
  children,
}) => (
  <Comment
    user={user.toJS()}
  >
    {children}
  </Comment>
);

export default TripDetailComment;
